import React from 'react';
import ShippingList from './shipping-list';
import './index.less';

export default function GuaranteedUnfoldShipping(
  props: ShippingTypes.Root & {
    i18n: DetailTypes.i18n;
  },
) {
  const { i18n, logisticsList = [], semiHosted = false, coreCountry = false } = props;
  // 无物流数据
  if (logisticsList.length === 0) return null;
  // 半托管品
  if (semiHosted === true && coreCountry === true) {
    return (
      <div className="shipping-layout">
        <h3>{i18n['202107_detail_pc_ShippingFloor_ShippingTitle']}</h3>
        <ShippingList {...props} />
      </div>
    );
  }
  return null;
}
